import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { DailyReportPoint } from '@barbeiropro/contracts';
import { money } from '@/lib/format';

const dayLabel = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
const compact = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 });

export function DailyChart({ data }: { data: DailyReportPoint[] }) {
  const total = data.reduce((s, d) => s + d.revenueCents, 0);
  return (
    <div role="img" aria-label={`Gráfico diário de faturamento e valor recebido, com ${data.length} dias. Faturamento total no período: ${money(total)}.`} className="h-72 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: 0 }}>
          <CartesianGrid stroke="var(--border)" vertical={false} />
          <XAxis dataKey="date" tickFormatter={dayLabel} tickLine={false} axisLine={false} fontSize={12} minTickGap={24} />
          <YAxis tickFormatter={(v: number) => compact.format(v / 100)} tickLine={false} axisLine={false} fontSize={12} width={48} />
          <Tooltip
            formatter={(v: number, name: string) => [money(v), name]}
            labelFormatter={(l: string) => `${dayLabel(l)}/${l.slice(0, 4)}`}
            contentStyle={{ borderRadius: 8, border: '1px solid var(--border)', background: 'var(--card)', fontSize: 13 }}
          />
          <Legend iconType="plainline" wrapperStyle={{ fontSize: 13 }} />
          <Line type="monotone" dataKey="revenueCents" name="Faturamento" stroke="var(--chart-1)" strokeWidth={2} dot={false} />
          <Line type="monotone" dataKey="receivedCents" name="Recebido" stroke="var(--chart-2)" strokeWidth={2} dot={false} strokeDasharray="5 3" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
